﻿import { acquireToken } from "@/config/authConfig";
import { msalInstance } from "@/index";

export const getAccessToken = async (): Promise<string | undefined> => {
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  const applicationId = msalInstance.getConfiguration().auth.clientId;
  const account = activeAccount || accounts[0];
  const acquireResult = await acquireToken(account, msalInstance, applicationId);
  return acquireResult.response?.accessToken;
};

export const authorizationHeaders = async (
  headers: Headers
): Promise<Headers> => {
  const accessToken = await getAccessToken();

  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }

  // Company is being hardcoded to `milwaukeetool` until this functionality is revisited in
  // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/9474
  headers.set("CompanyCode", "milwaukeetool");

  const storedUserToken = localStorage.getItem("userToken");

  if (!storedUserToken) return headers;

  const metUsersToken = JSON.parse(storedUserToken)?.token;

  if (metUsersToken) headers.set("met-users-token", metUsersToken);

  return headers;
};
